import { Box, Typography } from "@mui/material";
import SarodiIcon from "../../images/sarodi.svg";
import Linkedin from "../../images/linkedin.svg";
import Instagram from "../../images/instagram.svg";
import Aparat from "../../images/aparat.svg";
import BgVideo from "../../videos/bg-video.mp4";

const socialMediaIconsData = [
  {
    id: "linkedin",
    icon: Linkedin,
    href: "#",
  },
  {
    id: "instagram",
    icon: Instagram,
    href: "https://www.instagram.com/sarodi.co",
  },
  {
    id: "aparat",
    icon: Aparat,
    href: "https://www.aparat.com/sarodi.co",
  },
];

const Intro = () => {
  return (
    <Box
      sx={{
        position: "relative",
        maxWidth: "1920px",
        width: "100vw",
        height: "100dvh",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          opacity: ".4",
          width: "100vw",
          height: "100dvh",
        }}
      >
        <video
          style={{
            position: "absolute",
            objectFit: "cover",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            width: "100vw",
            height: "100dvh",
            maxWidth: "1920px !important",
            zIndex: "-10",
            overflow: "hidden",
          }}
          autoPlay
          loop
          muted
        >
          <source src={BgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box>
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "column",
          gap: ".5rem",
          textAlign: "left",
          position: "absolute",
          left: { xs: "2rem", md: "11rem" },
          bottom: "15rem",
        }}
      >
        <Typography
          textAlign="right"
          variant="h2"
          fontSize={{ xs: "1rem", md: "1.5rem", lg: "2rem" }}
        >
          در این محیط باید زیست
        </Typography>
        <Typography
          textAlign="justify"
          sx={{
            maxWidth: { xs: "250px", md: "470px" },
            fontSize: { xs: "10px", md: "1rem" },
          }}
        >
          ما به عنوان طراح و تولید کننده مــــحصولات بهداشتی ساختمانی همواره در
          تلاش بوده ایم تا با بالاترین کیفیت، راه کار های نوآورانه در جهت رفع
          نیازهای روزمره شما ارائه دهیم، اما دیگر حاضر نیستیم در مواجهه با چالش
          های زیست محیطی، صـرفا نـــظاره گر باشیم. تصمیم ما برای تغییر نام تجاری
          ناشی از درک عمیقی از تأثیر محصولات ما بر پایداری زیـست محیطی ست. با
          تغییر نام تجاری به Sarodi، ما تعهد خود را به طـــراحی و تولید
          محـــصولات بهداشتی ساختمانی پایدارتر نشان داده و به حفاظت از سیاره خود
          کمک می‌کنیم.
        </Typography>
      </Box>

      <Box
        sx={{
          paddingTop: { xs: "3rem", lg: "5rem", xl: "8rem" },
          left: { xs: "1rem", md: "5rem" },
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: ".5rem",
        }}
      >
        <Box
          sx={{
            width: { xs: "8rem", md: "15rem" },
          }}
        >
          <img
            src={SarodiIcon}
            style={{
              width: "100%",
              height: "100%",
            }}
            alt="Sarodi Icon."
          />
        </Box>
        <Box
          sx={{
            width: "2px",
            minHeight: { xs: "89dvh", lg: "55dvh", xl: "52dvh" },
            background: "#8B8B8B",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: { xs: "absolute", md: "static" },
            bottom: "5rem",
            paddingLeft: { xs: "1rem", md: "0" },
          }}
        >
          {socialMediaIconsData.map(({ icon, href, id }) => (
            <a href={href} key={id} target="_blank" rel="noreferrer">
              <img src={icon} alt={id} />
            </a>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Intro;
